import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './NoShowPolicyNotice.module.css';

/**
 * Short no-show policy on every booking surface.
 *
 * @param {Object} props
 * @param {boolean} [props.startNow]
 * @param {'talker'|'listener'} [props.role]
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
const NoShowPolicyNotice = ({ startNow = false, role = 'talker', className }) => {
  const id =
    role === 'listener'
      ? startNow
        ? 'NoShowPolicy.listenerStartNow'
        : 'NoShowPolicy.listenerScheduled'
      : startNow
        ? 'NoShowPolicy.talkerStartNow'
        : 'NoShowPolicy.talkerScheduled';
  return (
    <p
      className={classNames(css.root, className)}
      data-testid="no-show-policy"
      data-role={role}
      data-start-now={startNow ? 'true' : 'false'}
    >
      <FormattedMessage id={id} />
      {role === 'talker' ? (
        <>
          {' '}
          <a className={css.link} href="/faq#cancel" data-testid="no-show-policy-link">
            How cancelling works
          </a>
        </>
      ) : null}
    </p>
  );
};

export default NoShowPolicyNotice;
